module.exports = __webpack_public_path__ + "img/login_logo_white.5b229976.svg";